<template>
  <div class="library container bg-light">
    <div class="pt-4 mt-4 d-flex">
      <button
        type="button"
        class="btn btn-sm mr-1 btn-info"
        @click="saveAndReturn(true)"
        v-bind:disabled="isDisabled"
      >
        Salva & Ritorna
      </button>

      <button
        type="button"
        class="btn btn-sm mr-1 btn-success"
        @click="saveAndReturn(false)"
        v-bind:disabled="isDisabled"
      >
        Salva
      </button>

      <button
        type="button"
        class="btn btn-sm mr-1 btn-danger"
        @click="clickCancel"
      >
        Annulla
      </button>

      <div class="custom-control custom-switch align-self-center ml-3">
        <input
          type="checkbox"
          class="custom-control-input"
          id="customSwitch1"
          v-model="isEnabled"
        />
        <label class="custom-control-label text-dark" for="customSwitch1"
          >Abilita Modifiche</label
        >
      </div>

      <div class="ml-auto"></div>
      <a
        v-if="isEnabled"
        class="btn btn-sm mr-1 text-danger"
        href=""
        @click.prevent="deleteBook(book, $event.target)"
        >Cancella Libro</a
      >

      <button
        type="button"
        class="btn btn-sm mr-1 btn-dark "
        @click="goToPrevBook"
        v-bind:disabled="prevId == 0"
      >
        Libro Precedente
      </button>
      <button
        type="button"
        class="btn btn-sm btn-dark"
        @click="goToNextBook"
        v-bind:disabled="nextId == 0"
      >
        Libro Successivo
      </button>
    </div>
    <hr />

    <h4 class=" text-center text-dark">
      {{ book.autore }} - {{ book.titolo }}
    </h4>
    <hr />

    <form class="">
      <div class="form-group row mb-4">
        <label for="autore" class="col-sm-2 col-form-label"></label>

        <div class="col-sm-10">
          <img
            style="object-fit: cover; height:150px; width:150px; cursor:pointer;"
            class="img-thumbnail ml-1"
            v-for="(img, index) in images"
            :key="index"
            @click="openGallery(index)"
            v-lazy="img.thumb"
            alt=""
          />
        </div>
      </div>

      <LightBox
        :images="images"
        ref="lightbox"
        :show-caption="false"
        :show-light-box="false"
      >
      </LightBox>

      <!-- this.id arriva da params.id perchè altrimenti dovrei aspettare il load asincrono -->
      <book-edit
        v-bind:originalId="this.$route.params.id.toString()"
        :inputDisabled="isDisabled"
        :book="book"
        v-on:update:hasErrors="hasErrors = $event"
      >
      </book-edit>
    </form>

    <div class="mb-4 pb-4"></div>
  </div>
</template>

<script>
import LightBox from "vue-image-lightbox";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import BookEdit from "@/components/BookEdit.vue";
import appService from "@/service.js";

export default {
  components: {
    LightBox,
    "book-edit": BookEdit
  },
  data: function() {
    return {
      book: {},
      images: [],
      //id: this.$route.params.id,
      isEnabled: false,
      prevId: 0,
      nextId: 0
    };
  },
  watch: {
    // call again the method if the route changes
    $route: "loadData"
  },
  methods: {
    saveAndReturn(exit) {
      //salva dati
      var id = this.$route.params.id;
      var url = `/api/books/${id}`;

      this.axios
        .put(url, this.book)
        .then(() => {
          this.$notify({
            group: "notif",
            type: "success",
            duration: 2000,
            title: "<h4>Ok!</h4>",
            text: "Salvataggio effettuato!"
          });

          this.isEnabled = false;

          if (exit) {
            this.$router.push({ name: "library" });
          }
        })
        .catch(error => {
          console.log(error);

          // self.$notify({
          //   group: "foo",
          //   type: "error",
          //   duration: 2000,
          //   title: "Error",
          //   text: error.response.status + " - " + error.response.statusText
          // });
        });

      //this.$router.push({ name: 'details', params: { id: 'new' } })
    },
    clickCancel() {
      this.$router.push({ name: "library" });
    },
    loadData() {
      this.images = []; //cancella immagini
      var url = `/api/books/${this.$route.params.id}`;

      this.axios
        .get(url)
        .then(response => {
          //debugger

          //carica anche link next prev
          this.loadPrevNext();

          this.book = response.data[0];

          this.book.photos.forEach(element => {
            var obj = {};
            //obj.thumb = "/photos/_desert.jpg";
            obj.thumb = element.replace(".jpg", "_thumb.jpg");
            //obj.thumb = element;
            obj.src = element;

            console.log(obj);

            this.images.push(obj);
          });
        })
        .catch(error => {
          console.log(error);

          // self.$notify({
          //   group: "foo",
          //   type: "error",
          //   duration: 2000,
          //   title: "Error",
          //   text: error.response.status + " - " + error.response.statusText
          // });
        });
    },
    goToNextBook() {
      if (this.nextId) {
        this.$router.push({
          name: "details",
          params: {
            id: this.nextId
          }
        });
      }
    },
    goToPrevBook() {
      if (this.prevId) {
        this.$router.push({
          name: "details",
          params: {
            id: this.prevId
          }
        });
      }
    },
    loadPrevNext() {
      var url = `/api/books/prevnext/${this.$route.params.id}`;
      this.axios.get(url).then(response => {
        this.prevId = response.data.prevId;
        this.nextId = response.data.nextId;
      });
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
    deleteBook(book) {
      if (confirm(`Cancellare libro ID: ${book.id} - ${book.titolo} ?`)) {
        appService.deleteBook(book.id).then(() => {
          this.$notify({
            group: "notif",
            type: "success",
            duration: 2000,
            title: "<h4>Ok!</h4>",
            text: "Libro cancellato!"
          });

          //this.loadData();
          this.clickCancel();
        });
      }
    }
  },
  computed: {
    isDisabled() {
      return !this.isEnabled;
    }
  },
  created() {},
  mounted() {
    //var id = this.$route.params.id;
    this.loadData();
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem;
}
.form-control {
  font-size: 1rem;
}

table {
  text-align: left;
}

/* con * selecto gli ancestors */
.custom-switch * {
  cursor: pointer;
}
</style>
